import React, { forwardRef } from 'react';
import { css } from '@emotion/react';

export const cardStyles = css`
  flex: 0 0
    calc(
      (((100vw - (var(--margin) * 2)) - (var(--gutter) * 11)) / 12) * 5 +
        (4 * var(--gutter))
    );
  min-width: 0;
  text-decoration: none;
  margin-right: var(--gutter);
  overflow: hidden;
  @media (max-width: 700px) {
    flex-basis: calc(
      (((100vw - (var(--margin) * 2)) - (var(--gutter) * 11)) / 12) * 10 +
        (9 * var(--gutter))
    );
  }
  &:last-of-type {
    margin-right: 0;
  }
`;

const CardScroller = forwardRef(function CardScroller(
  { children, ...props },
  ref
) {
  return (
    <div
      {...props}
      ref={ref}
      className={`type--20 ${props.className || ''}`}
      css={css`
        display: flex;
        padding: 0 var(--margin) var(--margin);
        margin-bottom: var(--margin);
        overflow-x: scroll;
        &::after {
          content: '';
          display: block;
          flex: 0 0 var(--margin);
        }
      `}
    >
      {children}
    </div>
  );
});

export default CardScroller;
